import { render } from "./NasabahEdit.vue?vue&type=template&id=a11a9826&scoped=true"
import script from "./NasabahEdit.vue?vue&type=script&lang=js"
export * from "./NasabahEdit.vue?vue&type=script&lang=js"

import "./NasabahEdit.vue?vue&type=style&index=0&id=a11a9826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.20_vue@3.5.20_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11a9826"]])

export default __exports__